import React, { useState } from "react";

import {
  Button,
  Image,
  Box,
  Alert,
  AlertIcon,
  AlertDescription,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";
import { RiDeleteBinLine } from "react-icons/ri";

function Delete({ id, onDelete, images }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();

  const handleDelete = async () => {
    setLoading(true);

     let url = `https://media.seamarinetransport.com/php/delete.php`;

    const form_data = new FormData();
    form_data.append("filename", `${id}.jpg`);

    let headers = {
      method: "POST",
      body: form_data,
    };


    try {
      const response = await fetch(url, headers);
  
      if (response.ok) {
        updateImages();
        setLoading(false);
        onClose();
      } else {
        const message = await response.text();
        console.error("Error:", message);
        setLoading(false);
        setError("Failed to delete the image. Please try again.");
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  // Update the images state after deletion
  function updateImages() {
    const updatedImages = images.filter((image) => image.id !== id);
    onDelete(updatedImages);
  }

  return (
    <>
      <Button
        bg="rgba(255, 1, 1, 0.5)"
        color="white"
        onClick={onOpen}
        position="absolute"
        top={0}
        right={0}
        width="100%"
        height="100%"
        opacity={0}
        _hover={{ opacity: 1 }}
        _active={{ opacity: 1 }}
      >
        <RiDeleteBinLine size={40} />
      </Button>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader
              fontSize="lg"
              fontWeight="bold"
            >
              Delete Image
            </AlertDialogHeader>

            <AlertDialogBody>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                mb={4}
                background="#f7f7f7"
                borderRadius="md"
                padding="1rem"
              >
                <Image
                  src={`https://media.seamarinetransport.com/img/${id}.jpg`}
                  alt="Image to delete"
                  width="100%"
                  maxWidth="250px"
                  height="auto"
                  objectFit="cover"
                  borderRadius="md"
                />
              </Box>
              Are you sure? You can't undo this action afterwards.
              {error && (
                <Alert
                  status="error"
                  variant="solid"
                  mt={4}
                >
                  <AlertIcon />
                  <AlertDescription lineHeight="1.2">
                    <b>Error:</b> {error}
                  </AlertDescription>
                </Alert>
              )}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={cancelRef}
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button
                colorScheme="red"
                onClick={handleDelete}
                isLoading={loading}
                ml={3}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}

export default Delete;
